import { ResponsiveBar } from "@nivo/bar"

// 한국식 숫자 포맷
function formatKoreanNumber(value) {
  if (value >= 1e12) return (value / 1e12).toFixed(1).replace(/\.0$/, "") + "조"
  if (value >= 1e8) return (value / 1e8).toFixed(1).replace(/\.0$/, "") + "억"
  if (value >= 1e4) return (value / 1e4).toFixed(1).replace(/\.0$/, "") + "만"
  return value?.toString() ?? "0"
}

export default function NivoBarCombo({
  data,
  keys = ["value"],
  lineKeys = [],
  indexBy = "id",
  title,
  height = 400,
  groupMode = "grouped",
  colors,
  lineColors = {}
}) {
  if (!data || !data.length) return <p>No data available</p>

  // 0월 제거
  const cleaned = data.filter(d => d[indexBy] !== "0월")

  // 커스텀 라인 레이어
  const CustomLineLayer = (props) => {
    const { bars, xScale, yScale } = props

    return (
      <>
        {lineKeys.map((lineKey) => {
          const points = cleaned.map((d) => {
            return {
              x: xScale(d[indexBy]) + xScale.bandwidth() / 2,
              y: yScale(d[lineKey] ?? 0)
            }
          })

          const linePath = points
            .map((p, i) =>
              i === 0 ? `M ${p.x},${p.y}` : `L ${p.x},${p.y}`
            )
            .join(" ")

          return (
            <g key={lineKey}>
              {/* 라인 */}
              <path
                d={linePath}
                fill="none"
                stroke={lineColors[lineKey] || "#f00"}
                strokeWidth={3}
              />

              {/* 점 */}
              {points.map((p, idx) => (
                <circle
                  key={idx}
                  cx={p.x}
                  cy={p.y}
                  r={5}
                  fill="#fff"
                  stroke={lineColors[lineKey] || "#f00"}
                  strokeWidth={2}
                />
              ))}
            </g>
          )
        })}
      </>
    )
  }

  return (
    <div style={{ width: "100%", height }}>
      {title && (
        <h3 className="section-header">{title}</h3>
      )}

      <ResponsiveBar
        data={cleaned}
        keys={keys}
        indexBy={indexBy}
        groupMode={groupMode}
        margin={{ top: 60, right: 60, bottom: 80, left: 60 }}
        padding={0.3}
        colors={colors || { scheme: "set3" }}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: -30,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickValues: 5,
          format: formatKoreanNumber,
        }}
        label={(d) => formatKoreanNumber(d.value)}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        legends={[
          {
            anchor: "bottom",
            direction: "row",
            translateY: 60,
            itemWidth: 80,
            itemHeight: 20,
            symbolSize: 12,
            symbolShape: "circle",
            data: [
              // bar keys
              ...keys.map((k) => ({
                id: k,
                label: k,
                color: typeof colors === "function" ? colors({ id: k }) : colors?.[k] || "#000",
              })),
              {
                id: "spacer",
                label: " ",     // 공백 표시
                color: "transparent",
                symbolSize: 0,  // 심볼 안 보이게
              },
              // line keys
              ...lineKeys.map((k) => ({
                id: k,
                label: k,
                color: lineColors[k] || "#000",
              })),
            ],
          },
        ]}
        layers={[
          "grid",
          "axes",
          "bars",
          CustomLineLayer,   // 🔥 커스텀 라인 레이어 추가
          "legends",
        ]}
      />
    </div>
  )
}
